import { Button, Ui } from '@silvertours/front-shared';
import React from 'react';

export type SceneProps = {
  onClose: () => void;
  onConfirm: () => void;
};

export type WizardOverlayProps = {
  children: React.ReactNode;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  buttonText?: string;
  errorText?: string;
};

export const WizardOverlay = ({
  children,
  onClose,
  onConfirm,
  title,
  buttonText,
  errorText,
}: WizardOverlayProps) => (
  <Ui.Overlay
    title={title}
    titlePosition="left"
    footerContent={
      <>
        {errorText && (
          <Ui.Message severity={Ui.MessageSeverity.ERROR}>
            {errorText}
          </Ui.Message>
        )}
        {buttonText && (
          <Button
            onClick={onConfirm}
            type="submit"
            id="find"
            size="small"
            fullWidth
          >
            {buttonText}
          </Button>
        )}
      </>
    }
    open
    width="wide"
    onClose={onClose}
    fullViewport
  >
    {children}
  </Ui.Overlay>
);

export type Scene = {
  node: (props: SceneProps) => React.ReactNode;
  goBackOnClose?: boolean;
};
